export default __webpack_public_path__ + "static/media/membership-card-icon-active.cc60eb1a.svg";